<template>
  <van-overlay :show="show">
    <div class="popBox">
      <div class="contentPopBox">
        <div class="poptitle flex justify-center">提示</div>

        <div class="pop-content">
          <div class="audit-tip mb-10px">
            {{ isXygj ? '审核通过，将会扣减您的' + depositName + '余额增加至申请代理的' + depositName + '账户' : '请核对好信息后谨慎操作！' }}
          </div>
          <van-radio-group class="audit-radio" v-model="auditForm.status" direction="horizontal">
            <van-radio name="1">通过</van-radio>
            <van-radio name="2">作废</van-radio>
          </van-radio-group>
          <van-field
            class="audit-textarea"
            autosize
            v-model="auditForm.remark"
            type="textarea"
            placeholder="输入备注"
            :border="true"
            show-word-limit
            maxlength="150"
          />
        </div>

        <div class="flex justify-between items-center pop-btn-box">
          <div class="left-button" color="#f5f6f7" round block @click="cancel">取消</div>
          <div
            class="right-button"
            color="linear-gradient( 170deg, #FFB695 0%, #FD7F5C 100%)"
            round
            block
            type="primary"
            @click="confirm"
          >
            确定
          </div>
        </div>
      </div>
    </div>
  </van-overlay>
</template>
<script setup>
import { ref, toRefs, computed } from 'vue'
import { projectRules } from '@/enum'
import { useUserStore } from '@/store/user'
const props = defineProps(['show', 'auditForm', 'auditInfo'])
const emits = defineEmits(['cancel', 'confirm'])
const { show, auditForm, auditInfo } = toRefs(props)
const userStore = useUserStore()
const projectInfo = computed(() => userStore.getProjectInfo) //用户信息
const isXygj = computed(() => projectInfo.value.projectRule == projectRules.xygj)
const depositName = computed(() => userStore.getDepositName)
const cancel = () => {
  emits('cancel')
}
const confirm = () => {
  emits('confirm')
}
</script>
<style lang="less" scoped>
.popBox {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.popBottom {
  position: fixed;
  bottom: 0;
  width: 100%;
}

.contentPopBox {
  position: relative;
  width: 75%;
  min-height: 260px;
  max-height: 70%;
  padding-top: 16px;
  padding-bottom: 16px;
  box-sizing: border-box;
  border-radius: 10px;
  background: #fff;

  .poptitle {
    font-size: 18px;
    color: #222222;
    line-height: 24px;
    font-weight: 500;
  }

  .borderdiv {
    border: 1px solid #eee;
    width: 280px;
    height: 84px;
    overflow: hidden;
    background: #fff;
    margin: 0 auto 28px;
  }

  .pop-btn-box {
    position: absolute;
    width: 100%;
    left: 0;
    bottom: 16px;
    box-sizing: border-box;
    padding: 0 30px;
  }

  .btntwo {
    width: 124px;
    height: 40px;
  }

  .btnListSpecial {
    margin-left: 12px;
  }

  .poplable {
    font-size: 14px;
    color: #222222;
    line-height: 20px;
    margin: 0 20px 20px;
  }

  .cha {
    display: none;
    position: absolute;
    right: 12px;
    top: 20px;
    width: 24px;
    height: 24px;
  }
}

.audit-radio {
  justify-content: space-around;
  font-size: 14px;
}

.pop-content {
  padding: 16px 30px 30px;

  .audit-info {
    font-size: 14px;
    color: #222222;

    .audit-id {
      color: #999999;
    }
  }

  .audit-tip {
    text-align: center;
    font-size: 14px;
    color: #222222;
  }
}

.audit-textarea {
  padding: 5px;
  margin: 12px 0 20px;
  min-height: 32px;
  border: 1px solid rgba(216, 216, 216, 0.5);
}
</style>
